import { render, staticRenderFns } from "./create-homeSlider.vue?vue&type=template&id=2ce33c09&"
import script from "./create-homeSlider.vue?vue&type=script&lang=ts&"
export * from "./create-homeSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "create-homeSlider.vue"
export default component.exports